import request from '@/utils/request'

export function listPaymentPlans(projectId) {
  return request({
    url: `/api/payment-plan/by-project/${projectId}`,
    method: 'get'
  })
}

export function savePaymentPlan(data) {
  return request({
    url: '/api/payment-plan',
    method: 'post',
    data
  })
}

export function updatePaymentPlan(id, data) {
  return request({
    url: `/api/payment-plan/${id}`,
    method: 'put',
    data
  })
}

export function deletePaymentPlan(id) {
  return request({
    url: `/api/payment-plan/${id}`,
    method: 'delete'
  })
}
